import type { VoidFunctionComponent } from 'react';

import { useDialogContext } from '../../../contexts/DialogContext';
import useAsyncStatus from '../../../hooks/useAsyncStatus';
import { post } from '../../../redux/api';
import Button from '../../generic/Button';
import Card from '../../generic/Card/Card';
import Text from '../../generic/Text';

/**
 * Shows a button to trigger backfill of license identification data.
 */
export const BackfillLicenseIdentificationDataCard: VoidFunctionComponent = () => {
  const requestStatus = useAsyncStatus();
  const { onConfirm } = useDialogContext();

  const onButtonClick = () => {
    onConfirm({
      title: 'Backfill license identification data',
      body: (
        <div>
          Are you sure you want to backfill license identification data?
        </div>
      ),
      onConfirm: async () => {
        try {
          requestStatus.onPending();
          await post('/api/organizations/backfill-license-identification-data', {});
          requestStatus.onSuccess();
        } catch (e) {
          requestStatus.onError(e as Error);
        }
      },
    });
  };

  return (
    <Card isFullWidth padding="medium">
      <Card.Header>Backfill License Identification Data</Card.Header>
      <Card.Content>
        <Text.Paragraph>
          This will queue a background job that backfills the data required for IssuesV2
          license identification filter. This job will likely run for multiple hours.
        </Text.Paragraph>
        <Button onClick={onButtonClick}>
          Backfill
        </Button>
      </Card.Content>
    </Card>
  );
};

export default BackfillLicenseIdentificationDataCard;
